import styled from "styled-components";
import { TextField } from "@material-ui/core";

export const ProductList = styled.div`
  width: 100%;
  margin: 0px;
  padding: 0px;
  max-height: 36rem;
  overflow-y: auto;
`;

export const Field = styled(TextField)`
  width: 100%;
  margin-bottom: 20px !important;

  :last-child {
    margin-bottom: 10px !important;
  }
`;

export const CurrencyInput = styled(TextField)`
  width: 100%;
  margin-bottom: 20px !important;

  :last-child {
    margin-bottom: 10px !important;
  }
`;

export const NewProdItem = styled.strong``;
